import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-236b1d4b"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "evolution-split"
};
const _hoisted_2 = {
  class: "value"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_percentage_value = _resolveComponent("percentage-value");
  const _component_loading_element = _resolveComponent("loading-element");
  const _component_evolution_value = _resolveComponent("evolution-value");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString($props.split?.element?.value), 1), _createVNode(_component_evolution_value, {
    value: $props.split?.evolution
  }, {
    default: _withCtx(({
      color
    }) => [_createVNode(_component_loading_element, {
      loading: $props.loading,
      size: 35,
      style: _normalizeStyle({
        visibility: $props.split?.element !== null ? 'visible' : 'hidden'
      })
    }, {
      default: _withCtx(() => [_createVNode(_component_percentage_value, {
        style: _normalizeStyle({
          visibility: $props.split?.element !== null ? 'visible' : 'hidden'
        }),
        value: $props.split?.evolution,
        color: color,
        "show-sign": ""
      }, null, 8, ["style", "value", "color"])]),
      _: 2
    }, 1032, ["loading", "style"])]),
    _: 1
  }, 8, ["value"])]);
}